<div class="fc-signup-organization-selection-container">
    <div class="fc-signup-organization-selection-container-body">
        <h3 class="fc-signup-organization-selection-title">
            {{ 'SIGNUP.FORM.ORGANIZATION_SELECTOR.HEADER' | translate }}
        </h3>
        <div class="fc-signup-organization-selection">
            <button
                class="fc-signup-organization-selector"
                [ngClass]="{ selected: type === 'retailer' }"
                (click)="setType(organizationTypes.Retailer)"
                data-e2e-hook="retailer-organization"
            >
                <div class="fc-signup-organization-selector-type">
                    {{ 'SIGNUP.FORM.ORGANIZATION_SELECTOR.RETAILER.TITLE' | translate }}
                </div>
                <div class="fc-signup-organization-selector-description">
                    {{ 'SIGNUP.FORM.ORGANIZATION_SELECTOR.RETAILER.SUBTITLE' | translate }}
                </div>
            </button>
            <button
                class="fc-signup-organization-selector"
                [ngClass]="{ selected: type === 'manufacturer' }"
                (click)="setType(organizationTypes.Manufacturer)"
                data-e2e-hook="brand-organization"
            >
                <div class="fc-signup-organization-selector-type">
                    {{ 'SIGNUP.FORM.ORGANIZATION_SELECTOR.BRAND.TITLE' | translate }}
                </div>
                <div class="fc-signup-organization-selector-description">
                    {{ 'SIGNUP.FORM.ORGANIZATION_SELECTOR.BRAND.SUBTITLE' | translate }}
                </div>
            </button>
        </div>
    </div>
    <ng-container *ngIf="showOrgSwitcherLink$ | async">
        <div class="fc-signup-organization-selection-container-footer">
            <div class="fc-signup-organization-selection-container-footer-text">
                {{ 'SIGNUP.FORM.PLATFORM_ACCESS.TEXT1' | translate }}
            </div>
            <div class="fc-signup-organization-selection-container-footer-link">
                <a fcp-link [size]="fcpLinkSizes.Medium" (click)="login()">
                    {{ 'SIGNUP.FORM.PLATFORM_ACCESS.TEXT2' | translate }}
                </a>
            </div>
        </div>
    </ng-container>
</div>
